import cx from "classnames";
import ArticleCard from "@/components/articleCard";
import { Article } from "@/graphql/gql/graphql";
import ArticleList from "./ArticleList";
import styles from "./sport.module.scss";

const SportListColumn = ({
  articles,
  origin,
}: {
  articles: Article[];
  origin: string;
}) => {
  const [firstArticle, secondArticle, ...remainingArticles] = articles;

  return (
    <div className={cx(styles.listOffset, styles.articleContainer)}>
      {firstArticle && (
        <ArticleCard
          image={firstArticle?.hero?.imageUrl?.url}
          title={firstArticle.title}
          publishedOn={firstArticle.firstPublishedAt}
          description={firstArticle.description}
          link={`/${firstArticle.slug}`}
          author={firstArticle.author}
          origin={origin}
          sportName={firstArticle?.sport.name}
          sportSlug={firstArticle?.sport.slug}
          addBackground
        />
      )}
      {secondArticle && (
        <ArticleCard
          image={secondArticle?.hero?.imageUrl?.url}
          title={secondArticle?.title}
          publishedOn={secondArticle?.firstPublishedAt}
          description={secondArticle?.description}
          link={`/${secondArticle?.slug}`}
          author={secondArticle?.author}
          origin={origin}
          sportName={secondArticle?.sport.name}
          sportSlug={secondArticle?.sport.slug}
          addBackground
        />
      )}
      <div className={styles.listItems}>
        <ArticleList
          type="grid"
          articles={remainingArticles?.slice(0, 4)}
          origin={origin}
          sportName={firstArticle?.sport.name}
        />
      </div>
    </div>
  );
};

export default SportListColumn;
